import { motion } from "framer-motion";

const ARTICLES = [
  {
    tag: "PRIMER",
    date: "12.02.2025",
    title: "Term vs. Whole: what nobody explains at the dinner table.",
    excerpt:
      "The single question that determines which policy you actually need — and why most brokers won't ask it.",
    minutes: 6,
  },
  {
    tag: "FIELD GUIDE",
    date: "11.18.2025",
    title: "The DIME method: five minutes, one honest number.",
    excerpt:
      "How to calculate how much life insurance your family actually needs — without a spreadsheet.",
    minutes: 4,
  },
  {
    tag: "ESSAY",
    date: "10.30.2025",
    title: "A letter to the family you can't see yet.",
    excerpt:
      "On writing the beneficiary line. What it means to plan for the version of your household that continues without you.",
    minutes: 9,
  },
];

export default function Journal() {
  return (
    <section id="journal" className="bg-ink text-cream border-t border-cream/10 grain" data-testid="journal-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-20 gap-8">
          <div className="max-w-2xl">
            <div className="text-gold text-[11px] tracking-[0.3em] mb-8 flex items-center gap-4">
              <span className="w-8 h-[1px] bg-gold" />
              CHAPTER 08 · THE JOURNAL
            </div>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight">
              Field notes on <span className="italic text-gold">protection.</span>
            </h2>
          </div>
          <a href="#schedule" className="link-line text-[12px] tracking-[0.3em] text-cream/80 hover:text-gold self-start md:self-end" data-testid="journal-all-link">
            READ ALL &nbsp;→
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {ARTICLES.map((a, i) => (
            <motion.article
              key={a.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="group border-t border-cream/15 pt-8 cursor-pointer"
              data-testid={`article-${i}`}
            >
              <div className="flex justify-between text-[10px] tracking-[0.25em] text-cream/50 mb-8">
                <span className="text-gold">{a.tag}</span>
                <span>{a.date}</span>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight text-cream group-hover:text-gold transition-colors duration-500 mb-6">
                {a.title}
              </h3>
              <p className="text-cream/60 text-sm leading-relaxed mb-10 font-light">{a.excerpt}</p>
              <div className="flex justify-between items-center text-[11px] tracking-[0.2em] text-cream/50">
                <span>{a.minutes} MIN READ</span>
                <svg width="20" height="10" viewBox="0 0 20 10" className="transition-transform duration-500 group-hover:translate-x-2 text-gold" fill="none">
                  <path d="M0 5h18m0 0L14 1m4 4l-4 4" stroke="currentColor" strokeWidth="1"/>
                </svg>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
